import { motion } from "framer-motion";
import Parser from "html-react-parser";
import {getMediaDetails} from "../../lib/getMediaDetails";
import LazyImage from "../../components/Lazyloader";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

export default function PostCard({ product, colLg }) {
    const title = product.title?.rendered || "Titre non disponible";
    const slug = product.slug || "unknown-slug";

    const [imageSrc, setImageSrc] = useState("");
    const [categoryNames, setCategoryNames] = useState([]);

    useEffect(() => {
        const fetchImage = async () => {
            if (product.featured_media) {
                const mediaDetails = await getMediaDetails(product.featured_media);
                if (mediaDetails?.source_url) {
                    setImageSrc(mediaDetails.source_url);
                }
            }
        };

        fetchImage();
    }, [product.featured_media]);

    useEffect(() => {
        const fetchCategories = async () => {
            if (product.categories && product.categories.length > 0) {
                try {
                    const include = product.categories.join(",");
                    const url = `${process.env.REACT_APP_WP_API_URL_V2}/categories?include=${include}`;
                    const response = await fetch(url);
                    const categories = await response.json();
                    const categoryNames = categories.map(category => category.name);
                    setCategoryNames(categoryNames);
                } catch (error) {
                    console.error("Erreur lors de la récupération des catégories :", error);
                }
            }
        };

        fetchCategories();
    }, [product.categories]);


    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        return new Intl.DateTimeFormat("fr-FR", {
            day: "numeric",
            month: "long",
            year: "numeric",
        }).format(date);
    };

    const motionSettings = {
        initial: { opacity: 0.6, y: 50 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0 },
        transition: { duration: 0.4 },
    };

    return (
        <motion.div
            className={`blog-block`}
            layout
            {...motionSettings}
        >
            <div className="post-card">
                <div className="image-box">
                    <Link to={`/blog/${slug}`} title={Parser(title)}>
                        <figure className="image">
                            <ul className="card-category-list">
                                {categoryNames.map((name, index) => (
                                    <li key={index} className="privacy">{name}</li>
                                ))}
                            </ul>
                            <LazyImage src={imageSrc} alt={`Image de ${Parser(title)}`} width="100%" height="auto"/>
                        </figure>
                    </Link>
                </div>

                <div className="lower-content">
                    <ul className="post-meta">
                        <li>{product?.date ? formatDate(product.date) : ''}</li>
                        <li>Par {product?.author_info?.name || 'Talents Handicap'}</li>
                    </ul>
                    <Link to={`/blog/${slug}`}  className="titleForum" title={Parser(title)}>{Parser(title)}</Link>
                </div>
            </div>
        </motion.div>
    );
}
